import { render } from "./DashboardLeft.vue?vue&type=template&id=0e04a77c&scoped=true"
import script from "./DashboardLeft.vue?vue&type=script&lang=js"
export * from "./DashboardLeft.vue?vue&type=script&lang=js"

import "./DashboardLeft.vue?vue&type=style&index=0&id=0e04a77c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e04a77c"]])

export default __exports__